var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 113,
    viewBox: "0 0 96 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6349 44.893H27.4021V78.752C27.4021 82.4765 30.4494 85.5239 34.1739 85.5239H61.2611C64.9856 85.5239 68.0329 82.4765 68.0329 78.752V44.893H78.8001C84.827 44.893 87.8743 37.5794 83.6081 33.3131L52.5255 2.2305C51.899 1.60273 51.1549 1.10468 50.3356 0.764858C49.5164 0.425038 48.6383 0.250122 47.7514 0.250122C46.8645 0.250122 45.9863 0.425038 45.1671 0.764858C44.3479 1.10468 43.6037 1.60273 42.9772 2.2305L11.8946 33.3131C7.6284 37.5794 10.608 44.893 16.6349 44.893ZM0.382568 105.839C0.382568 109.564 3.42988 112.611 7.15438 112.611H88.4161C92.1406 112.611 95.1879 109.564 95.1879 105.839C95.1879 102.115 92.1406 99.0675 88.4161 99.0675H7.15438C3.42988 99.0675 0.382568 102.115 0.382568 105.839Z",
    fill: "#058998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector (5).2d6fed7ab662f560531a3c148d19e702.svg";
export { ForwardRef as ReactComponent };